import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";

const topGuides = [
  {
    title: "Effektiv ränta",
    description: "Förstå den verkliga lånekostnaden innan du jämför erbjudanden.",
    slug: "effektiv-ranta",
    category: "Lån",
  },
  {
    title: "Kontantinsats och bolånetak",
    description: "Se hur 85-procentsregeln påverkar ditt bostadsköp.",
    slug: "kontantinsats-och-bolanetak",
    category: "Bolån",
  },
  {
    title: "Kreditupplysning",
    description: "Vad långivare tittar på och hur UC påverkar din jämförelse.",
    slug: "kreditupplysning",
    category: "Kredit",
  },
  {
    title: "Lån utan UC",
    description: "När det kan vara relevant och vilka risker du ska förstå först.",
    slug: "lana-utan-uc",
    category: "Lån",
  },
  {
    title: "Ränteavdrag",
    description: "Så påverkar ränteavdraget den faktiska kostnaden för lån.",
    slug: "ranteavdrag",
    category: "Skatt",
  },
  {
    title: "Reporänta",
    description: "Varför Riksbankens ränta påverkar bolån och andra lån.",
    slug: "reporanta",
    category: "Ränta",
  },
];

export const TopGuidesSection = () => {
  const { currentLanguage } = useLanguage();

  return (
    <div className="divide-y rounded-lg border bg-surface">
      {topGuides.map((guide) => (
        <Link
          key={guide.slug}
          to={`/${currentLanguage}/guider/${guide.slug}`}
          className="group flex items-center justify-between gap-4 px-4 py-3 transition-colors hover:bg-primary/5"
        >
          <span className="min-w-0">
            <span className="block text-xs font-semibold uppercase tracking-wide text-primary">
              {guide.category}
            </span>
            <span className="mt-1 block text-base font-semibold leading-6 text-foreground">
              {guide.title}
            </span>
            <span className="mt-1 block text-sm leading-5 text-muted-foreground">
              {guide.description}
            </span>
          </span>
          <ArrowRight className="h-4 w-4 flex-shrink-0 text-primary transition-transform group-hover:translate-x-1" />
        </Link>
      ))}
    </div>
  );
};
